import http from './http';

import { createLogger } from '../utils/logger';

const logger = createLogger('traditionsRituals');
export interface TraditionsRitualsData {
  id?: string;
  traditionsContent?: string;
  isLocked?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTraditionsRitualsRequest {
  traditionsContent: string;
}

export interface UpdateTraditionsRitualsRequest {
  traditionsContent?: string;
}

export const traditionsRitualsService = {
  createTraditionsRituals: async (data: CreateTraditionsRitualsRequest): Promise<TraditionsRitualsData> => {
    try {
      logger.debug('[Service] Creating traditions rituals with data:', data);
      const response = await http.post('/api/traditions-rituals', data);
      logger.debug('[Service] Create response:', response.data);
      // Backend returns { success: true, data: {...} }, so access .data.data
      return response.data.data;
    } catch (error: any) {
      logger.error('[Service] Error creating traditions rituals:', error);
      throw error;
    }
  },

  updateTraditionsRituals: async (id: string, data: UpdateTraditionsRitualsRequest): Promise<TraditionsRitualsData> => {
    try {
      logger.debug('[Service] Updating traditions rituals with ID:', id, 'data:', data);
      const response = await http.patch(`/api/traditions-rituals/${id}`, data);
      logger.debug('[Service] Update response:', response.data);
      // Backend returns { success: true, data: {...} }, so access .data.data
      return response.data.data;
    } catch (error: any) {
      logger.error('[Service] Error updating traditions rituals:', error);
      throw error;
    }
  },

  getTraditionsRituals: async (): Promise<TraditionsRitualsData[]> => {
    try {
      logger.debug('[Service] Getting all traditions rituals');
      const response = await http.get('/api/traditions-rituals');
      logger.debug('[Service] Get all response:', response.data);
      // Backend returns { success: true, data: [...] }, so access .data.data
      return response.data.data || [];
    } catch (error: any) {
      logger.error('[Service] Error getting traditions rituals:', error);
      throw error;
    }
  },

  getTraditionsRitualsById: async (id: string): Promise<TraditionsRitualsData> => {
    try {
      logger.debug('[Service] Getting traditions rituals by ID:', id);
      const response = await http.get(`/api/traditions-rituals/${id}`);
      logger.debug('[Service] Get by ID response:', response.data);
      // Backend returns { success: true, data: {...} }, so access .data.data
      return response.data.data;
    } catch (error: any) {
      logger.error('[Service] Error getting traditions rituals by ID:', error);
      throw error;
    }
  },

  deleteTraditionsRituals: async (id: string): Promise<void> => {
    try {
      logger.debug('[Service] Deleting traditions rituals with ID:', id);
      await http.delete(`/api/traditions-rituals/${id}`);
      logger.debug('[Service] Delete completed');
    } catch (error: any) {
      logger.error('[Service] Error deleting traditions rituals:', error);
      throw error;
    }
  },

  lockTraditionsRituals: async (id: string): Promise<void> => {
    try {
      logger.debug('[Service] Locking traditions rituals with ID:', id);
      await http.post(`/api/traditions-rituals/${id}/lock`);
      logger.debug('[Service] Lock completed');
    } catch (error: any) {
      logger.error('[Service] Error locking traditions rituals:', error);
      throw error;
    }
  },

  unlockTraditionsRituals: async (id: string, granteeEmails: string[]): Promise<void> => {
    try {
      logger.debug('[Service] Unlocking traditions rituals with ID:', id, 'for emails:', granteeEmails);
      await http.post(`/api/traditions-rituals/${id}/unlock`, { granteeEmails });
      logger.debug('[Service] Unlock completed');
    } catch (error: any) {
      logger.error('[Service] Error unlocking traditions rituals:', error);
      throw error;
    }
  },

  getTraditionsRitualsAccessGrants: async (id: string): Promise<any[]> => {
    try {
      logger.debug('[Service] Getting access grants for traditions rituals with ID:', id);
      const response = await http.get(`/api/traditions-rituals/${id}/access-grants`);
      logger.debug('[Service] Access grants response:', response.data);
      // Backend returns { success: true, data: [...] }, so access .data.data
      return response.data.data || [];
    } catch (error: any) {
      logger.error('[Service] Error getting traditions rituals access grants:', error);
      throw error;
    }
  },
};